<template>
    <div class="print-d-block tw-flex tw-flex-col tw-space-y-4 tw-overflow-y-auto tw-px-2 tw-overflow-x-hidden">
        <div @click="handleExpandAll" class="print-hidden tw-text-blue-600 tw-ml-auto tw-cursor-pointer hover:tw-text-blue-400 tw-inline-flex">
            <template v-if="!adverseCard.expandedPanel">Expand All</template>
            <template v-else>Collapse All</template>
        </div>
        <!-- <div class="tw-text-base tw-text-gray-700 tw-mb-2 tw-font-bold tw-mt-4" v-if="getMasterFields(adverseCard.doc.fields).length > 0 && adverseCard.doc">Details</div>
        <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2" v-if="getMasterFields(adverseCard.doc.fields).length > 0 && adverseCard.doc">
            <div v-for="field in getMasterFields(adverseCard.doc.fields)" class="tw-break-words" :key="field.value">
                <span class="tw-font-medium">{{ field.name }}: </span>
                <template v-if="urlFields.includes(field.name.toLowerCase())">
                    <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                </template>
                <template v-else>{{ field.value }}</template>
            </div>
        </div> -->

        <div class="tw-mb-2">
            <template v-if="adverseCard.doc && getMasterFields(adverseCard.doc.fields).length > 0">
                <div @click="fetchMoreInfo(adverseCard, 'detailsComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Details</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.detailsComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.detailsComplyExpanded">
                    <!-- <span v-for="keyword in adverseCard.keywords" :key="keyword.KEYWORD">
                        {{ get(keyword, "FULL_NAME_OF_SOURCE", "N/A") }}
                    </span> -->
                    <div class="tw-flex tw-space-x-2" v-for="(field, index) in getMasterFields(adverseCard.doc.fields)" :key="field.value">
                        <template v-if="field.name == 'Countries'">
                            <div class="tw-w-1/3 lg:tw-w-1/4 tw-font-semibold tw-text-left tw-py-2 tw-pr-3 tw-text-gray-400" :identifier="`['data']['fields'][${index}]['name']`">
                                {{ field.name }}
                            </div>
                            <div class="tw-w-2/3 lg:tw-h-3/4 tw-pl-3 tw-pr-3 tw-py-2">
                                <div class="tw-flex tw-justify-between tw-items-center">
                                    <span class="tw-space-y-2" :identifier="`['data']['fields'][${index}]['value']`">
                                        <!--<template v-if="urlFields.includes(field.name.toLowerCase())">
                                        <a class="tw-no-underline tw-tlext-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                                    </template>-->
                                        <template>{{ field.value }}</template>
                                    </span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Details</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.detailsComplyExpanded"></div>
            </template>
        </div>

        <div class="tw-mb-2">
            <template v-if="adverseCard.doc.associates">
                <div @click="fetchMoreInfo(adverseCard, 'associatesComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Associates</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.associatesComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.associatesComplyExpanded">
                    <div class="tw-gap-y-1 tw-gap-x-2 tw-mt-2" v-if="adverseCard.doc.associates">
                        <div v-for="(associate, index) in adverseCard.doc.associates" class="tw-break-words tw-capitalize" :key="associate.association">
                            <div class="tw-flex">
                                <div class="tw-inline-block tw-flex-wrap tw-mb-1">
                                    <span class="tw-font-medium tw-break-words" :identifier="`['data']['associates'][${index}]['name']`">
                                        {{ associate.name }}
                                    </span>
                                    <span :identifier="`['data']['associates'][${index}]['association']`"> ({{ associate.association }}) </span>
                                </div>
                                <neo-analyse class="tw-ml-2" v-if="associate.name" source="name" :value="associate.name"></neo-analyse>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Associates</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.associatesComplyExpanded"></div>
            </template>
        </div>

        <div class="tw-mb-2">
            <template v-if="checkSanction(adverseCard.doc.source_notes)">
                <div @click="fetchMoreInfo(adverseCard, 'sanctionsComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Sanctions</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.associatesComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.sanctionsComplyExpanded">
                    <div class="tw-grid tw-grid-cols-1 tw-gap-y-2 tw-gap-x-2" v-if="checkSanction(adverseCard.doc.source_notes)">
                        <template v-for="(i, j) in adverseCard.doc.source_notes">
                            <article v-if="i.aml_types && i.aml_types.includes('sanction')" :key="j">
                                <template>
                                    <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2">
                                        <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name'] ['data']['source_notes']['${j}']['url'] `">
                                            {{ i.name }}
                                        </a>
                                        <div class="tw-mt-1 tw-text-sm">
                                            Listed:
                                            <span class="tw-font-medium" :identifier="`['data']['source_notes']['${j}']['listing_started_utc'] ['data']['source_notes']['${j}']['listing_ended_utc']`"> {{ parseDate(i.listing_started_utc) }} - {{ i.listing_ended_utc ? parseDate(i.listing_ended_utc) : "Present" }} </span>
                                            <span class="tw-ml-8" v-if="i.listing_ended_utc">
                                                Removed:
                                                <span class="tw-font-medium" :identifier="`['data']['source_notes']['${j}']['listing_ended_utc']`">
                                                    {{ i.listing_ended_utc ? parseDate(i.listing_ended_utc) : "Present" }}
                                                </span>
                                            </span>
                                        </div>
                                        <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                            <div v-for="(field, index) in getFilteredFields(adverseCard.doc.fields, j)" class="tw-break-words" :key="field.value + '0' + index">
                                                <span class="tw-font-medium" :identifier="`['data']['fields'][${index}]['name']`">{{ field.name }}: </span>
                                                <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                    <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :identifier="`['data']['fields'][${index}]['value']`" :href="field.value">{{ field.value }}</a>
                                                </template>
                                                <template v-else>
                                                    <span :identifier="`['data']['fields'][${index}]['value']`" class="">
                                                        {{ field.value }}
                                                    </span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </article>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Sanctions</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.sanctionsComplyExpanded"></div>
            </template>
        </div>
        <!-- <div class="tw-text-base tw-text-gray-700 tw-mb-2 tw-font-bold tw-mt-4" v-if="checkSanction(adverseCard.doc.source_notes)">Sanctions</div>
        <div class="print-d-block tw-grid tw-grid-cols-1 tw-gap-y-2 tw-gap-x-2" v-if="checkSanction(adverseCard.doc.source_notes)">
            <article v-for="(i, j) in adverseCard.doc.source_notes" :key="j">
                <template v-if="i && i.aml_types[0] == 'sanction'">
                    <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2">
                        <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium">{{ i.name }}</a>
                        <div class="tw-mt-1 tw-text-sm">
                            Listed: <span class="tw-font-medium">{{ parseDate(i.listing_started_utc) }} - {{ i.listing_ended_utc ? parseDate(i.listing_ended_utc) : "Present" }}</span>
                            <span class="tw-ml-8" v-if="i.listing_ended_utc">
                                Removed: <span class="tw-font-medium">{{ i.listing_ended_utc ? parseDate(i.listing_ended_utc) : "Present" }}</span>
                            </span>
                        </div>
                        <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                            <div v-for="field in getFilteredFields(adverseCard.doc.fields, j)" class="tw-break-words" :key="field.value">
                                <span class="tw-font-medium">{{ field.name }}: </span>
                                <template v-if="urlFields.includes(field.name.toLowerCase())">
                                    <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                                </template>
                                <template v-else>{{ field.value }}</template>
                            </div>
                        </div>
                    </div>
                </template>
            </article>
        </div> -->

        <div class="tw-mb-2">
            <template v-if="checkPepList(adverseCard.doc.source_notes)">
                <div @click="fetchMoreInfo(adverseCard, 'warningComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">PEP / Warnings Details</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.warningComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.warningComplyExpanded">
                    <div class="tw-gap-y-1 tw-gap-x-2 tw-mt-2" v-if="checkPepList(adverseCard.doc.source_notes)">
                        <template v-for="(i, j) in adverseCard.doc.source_notes">
                            <article :key="j" v-if="i.aml_types && i.aml_types.includes('warning')">
                                <template>
                                    <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2 tw-mb-3">
                                        <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name'] ['data']['source_notes']['${j}']['url']`">
                                            {{ i.name }}
                                        </a>
                                        <div class="tw-mt-1 tw-text-sm">
                                            Listed:
                                            <span class="tw-font-medium" :identifier="`['data']['source_notes']['${j}']['listing_started_utc'] ['data']['source_notes']['${j}']['listing_ended_utc']`"> {{ parseDate(i.listing_started_utc) }} - {{ i.listing_ended_utc ? parseDate(i.listing_ended_utc) : "Present" }} </span>
                                            <span class="tw-ml-8" v-if="i.listing_ended_utc">
                                                Removed:
                                                <span class="tw-font-medium" :identifier="`['data']['source_notes']['${j}']['listing_ended_utc']`">{{ i.listing_ended_utc ? parseDate(i.listing_ended_utc) : "Present" }}</span>
                                            </span>
                                        </div>
                                        <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                            <div v-for="(field, index) in getFilteredFields(adverseCard.doc.fields, j)" class="tw-break-words" :key="field.value + index">
                                                <span class="tw-font-medium" :identifier="`['data']['fields'][${index}]['name']`"> {{ field.name }}: </span>
                                                <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                    <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :identifier="`['data']['fields'][${index}]['value']`" :href="field.value">
                                                        {{ field.value }}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <span class="" :identifier="`['data']['fields'][${index}]['value']`">
                                                        {{ field.value }}
                                                    </span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </article>
                        </template>
                    </div>
                </div>
            </template>
            <template>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">PEP / Warnings Details</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.warningComplyExpanded"></div>
            </template>
        </div>

        <!-- <div class="tw-text-base tw-text-gray-700 tw-mb-2 tw-font-bold tw-mt-4" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-1') && adverseCard.doc">Pep Class 1</div>
        <div class="print-d-block tw-grid tw-grid-cols-1 tw-gap-y-2 tw-gap-x-2" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-1')">
            <section v-for="(i, j) in adverseCard.doc.source_notes" :key="j">
                <template v-if="i.aml_types[0] == 'pep-class-1'">
                    <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                        <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium">{{ i.name }}</a>
                        <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                            <div v-for="field in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name" class="tw-break-words">
                                <span class="tw-font-medium">{{ field.name }}: </span>
                                <template v-if="urlFields.includes(field.name.toLowerCase())">
                                    <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                                </template>
                                <template v-else>{{ field.value }}</template>
                            </div>
                        </div>
                    </div>
                </template>
            </section>
        </div> -->
        <div class="tw-mb-2">
            <template v-if="adverseCard.doc && (checkPep4(adverseCard.doc.source_notes, 'pep-class-1') || checkPep4(adverseCard.doc.source_notes, 'pep-class-2') || checkPep4(adverseCard.doc.source_notes, 'pep-class-3') || checkPep4(adverseCard.doc.source_notes, 'pep-class-4') || checkPep4(adverseCard.doc.source_notes))">
                <div @click="fetchMoreInfo(adverseCard, 'pepDetails')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Pep Listing</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.pepDetailsExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.pepDetailsExpanded">
                    <div class="tw-text-base tw-mb-3 tw-mt-4 tw-font-bold">Pep</div>
                    <template v-if="adverseCard.doc">
                        <div class="tw-grid-cols-1 tw-mb-4 tw-gap-y-2 tw-gap-x-2">
                            <section v-for="(i, j, index) in adverseCard.doc.source_notes" :key="j">
                                <template v-if="i.name == 'ComplyAdvantage PEP Data'">
                                    <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                                        <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name']`">
                                            {{ i.name }}
                                        </a>
                                        <div class="tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                            <div v-for="(field, idx) in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name + '___' + idx" class="tw-break-words">
                                                <span class="tw-font-medium">{{ field.name }}: </span>
                                                <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                    <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value" :identifier="`['data']['source_notes']['${j}']['value']`">{{ field.value }}</a>
                                                </template>
                                                <template v-else>{{ field.value }}</template>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="Object.keys(adverseCard.doc.source_notes).length - 1 == index && checkComplyAdvantage(adverseCard.doc.source_notes) == 0"> No data found! </template>
                                </template>
                            </section>
                        </div>
                    </template>
                    <template v-else> No data found! </template>
                    <div class="tw-text-base tw-my-3 tw-font-bold">Pep Class 1</div>
                    <!-- <div class="tw-mb-2 tw-flex tw-space-x-2" v-for="field in getMasterFields(adverseCard.doc.fields)" :key="field.value">
                        <div class="tw-w-1/3 lg:tw-w-1/4 tw-font-semibold tw-text-left tw-py-2 tw-pr-3 tw-text-gray-400" v-if="field.name!='Countries'">{{ field.name }}</div>
                        <div class="tw-w-2/3 lg:tw-h-3/4 tw-pl-3 tw-pr-3 tw-py-2" v-if="field.name!='Countries'">
                            <div class="tw-flex tw-justify-between tw-items-center">
                                <span class="tw-space-y-2">
                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                                    </template>
                                    <template v-else>{{ field.value }}</template>
                                </span>
                            </div>
                        </div>
                    </div> -->
                    <template v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-1') && adverseCard.doc">
                        <div class="tw-grid tw-grid-cols-1 tw-mb-2 tw-gap-y-2 tw-gap-x-2" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-1')">
                            <template v-for="(i, j) in adverseCard.doc.source_notes">
                                <section v-if="i.aml_types && i.aml_types.includes('pep-class-1') && i.name != 'ComplyAdvantage PEP Data'" :key="j">
                                    <template>
                                        <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                                            <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium">{{ i.name }}</a>
                                            <div class="tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                                <div v-for="(field, j) in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name" class="tw-break-words">
                                                    <span class="tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name']`">{{ field.name }} {{ adverseCard.doc.source_notes.length }}: </span>
                                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :identifier="`['data']['source_notes']['${j}']['value']`" :href="field.value">
                                                            {{ field.value }}
                                                        </a>
                                                    </template>
                                                    <template v-else>{{ field.value }}</template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </section>
                                <template v-else>
                                    <template v-if="checkPepLength(adverseCard.doc.source_notes, 'pep-class-1') == 1 && i.name == 'ComplyAdvantage PEP Data' && i && i.aml_types && i.aml_types.includes('pep-class-1')">No data found!</template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else> No data found! </template>

                    <div class="tw-text-base tw-mb-3 tw-mt-4 tw-font-bold">Pep Class 2</div>
                    <template v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-2') && adverseCard.doc">
                        <div class="tw-grid-cols-1 tw-mb-4 tw-gap-y-2 tw-gap-x-2" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-2')">
                            <template v-for="(i, j) in adverseCard.doc.source_notes">
                                <section v-if="i.aml_types && i.aml_types.includes('pep-class-2') && i.name != 'ComplyAdvantage PEP Data'" :key="j">
                                    <template>
                                        <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                                            <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name']`">
                                                {{ i.name }}
                                            </a>
                                            <div class="tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                                <div v-for="(field, idx) in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name + '___' + idx" class="tw-break-words">
                                                    <span class="tw-font-medium">{{ field.name }}: </span>
                                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :identifier="`['data']['fields'][${idx}}]['value']`" :href="field.value">{{ field.value }}</a>
                                                    </template>
                                                    <template v-else>{{ field.value }}</template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </section>
                                <template v-else>
                                    <template v-if="checkPepLength(adverseCard.doc.source_notes, 'pep-class-2') == 1 && i.name == 'ComplyAdvantage PEP Data' && i && i.aml_types && i.aml_types.includes('pep-class-2')">No data found!</template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else> No data found! </template>

                    <div class="tw-text-base tw-mb-3 tw-mt-4 tw-font-bold">Pep Class 3</div>
                    <template v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-3') && adverseCard.doc">
                        <div class="tw-grid-cols-1 tw-mb-4 tw-gap-y-2 tw-gap-x-2" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-3')">
                            <template v-for="(i, j) in adverseCard.doc.source_notes">
                                <section v-if="i.aml_types && i.aml_types.includes('pep-class-3') && i.name != 'ComplyAdvantage PEP Data'" :key="j">
                                    <template>
                                        <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                                            <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name']`">
                                                {{ i.name }}
                                            </a>
                                            <div class="tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                                <div v-for="(field, idx) in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name + idx" class="tw-break-words">
                                                    <span class="tw-font-medium">{{ field.name }}: </span>
                                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value" :identifier="`['data']['fields'][${idx}]['value']`">
                                                            {{ field.value }}
                                                        </a>
                                                    </template>
                                                    <template v-else>{{ field.value }}</template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </section>
                                <template v-else>
                                    <template v-if="checkPepLength(adverseCard.doc.source_notes, 'pep-class-3') == 1 && i.name == 'ComplyAdvantage PEP Data' && i && i.aml_types && i.aml_types.includes('pep-class-3')">No data found!</template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else> No data found! </template>

                    <div class="tw-text-base tw-mb-3 tw-mt-4 tw-font-bold">Pep Class 4</div>
                    <template v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-4') && adverseCard.doc">
                        <div class="tw-grid-cols-1 tw-mb-4 tw-gap-y-2 tw-gap-x-2" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-4')">
                            <template v-for="(i, j) in adverseCard.doc.source_notes">
                                <section v-if="i.aml_types && i.aml_types.includes('pep-class-4') && i.name != 'ComplyAdvantage PEP Data'" :key="j">
                                    <template>
                                        <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                                            <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium" :identifier="`['data']['source_notes']['${j}']['name']`">
                                                {{ i.name }}
                                            </a>
                                            <div class="tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                                <div v-for="(field, idx) in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name + idx" class="tw-break-words">
                                                    <span class="tw-font-medium" :identifier="`['data']['fields'][${idx}]['name']`">{{ field.name }}: </span>
                                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                                                    </template>
                                                    <template v-else>{{ field.value }}</template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </section>
                                <template v-else>
                                    <template v-if="checkPepLength(adverseCard.doc.source_notes, 'pep-class-4') == 1 && i.name == 'ComplyAdvantage PEP Data' && i && i.aml_types && i.aml_types.includes('pep-class-4')">No data found!</template>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else> No data found! </template>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">PEP Listings</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.pepDetailsExpanded"></div>
            </template>
        </div>
        <!-- 
        <div class="tw-mb-2">
            <div ref="refpep2Comply" @click="fetchMoreInfo(adverseCard, 'pep2Comply')" class="print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                <div class="tw-text-lg tw-font-medium">Pep Class 2</div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{ 'tw-rotate-180': adverseCard.pep2ComplyExpanded }" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
            <div class="tw-p-2" v-if="adverseCard.pep2ComplyExpanded">
                <template v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-2') && adverseCard.doc">
                    <div class="print-d-block tw-grid tw-grid-cols-1 tw-gap-y-2 tw-gap-x-2" v-if="checkPep4(adverseCard.doc.source_notes, 'pep-class-2')">
                        <section v-for="(i, j) in adverseCard.doc.source_notes" :key="j">
                            <template v-if="i.aml_types[0] == 'pep-class-2'">
                                <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i">
                                    <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium">{{ i.name }}</a>
                                    <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                        <div v-for="field in getFilteredFields(adverseCard.doc.fields, j)" :key="field.name" class="tw-break-words">
                                            <span class="tw-font-medium">{{ field.name }}: </span>
                                            <template v-if="urlFields.includes(field.name.toLowerCase())">
                                                <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                                            </template>
                                            <template v-else>{{ field.value }}</template>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </section>
                    </div>
                </template>
                <template v-else> No data found! </template>
            </div>
        </div>

        <div class="tw-mb-2">
            <div ref="refpep3Comply" @click="fetchMoreInfo(adverseCard, 'pep3Comply')" class="print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                <div class="tw-text-lg tw-font-medium">Pep Class 3</div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{ 'tw-rotate-180': adverseCard.pep3ComplyExpanded }" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
            <div class="tw-p-2" v-if="adverseCard.pep3ComplyExpanded">
               
            </div>
        </div>

        <div class="tw-mb-2">
            <div ref="refpep4Comply" @click="fetchMoreInfo(adverseCard, 'pep4Comply')" class="print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                <div class="tw-text-lg tw-font-medium">Pep Class 4</div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{ 'tw-rotate-180': adverseCard.pep4ComplyExpanded }" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>
            <div class="tw-p-2" v-if="adverseCard.pep4ComplyExpanded">
                
            </div>
        </div> -->

        <div class="tw-mb-2">
            <template v-if="checkFitnessProbityList(adverseCard.doc.source_notes)">
                <div @click="fetchMoreInfo(adverseCard, 'fitnessComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Fitness Probity</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.fitnessComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.fitnessComplyExpanded">
                    <article v-for="(i, j) in adverseCard.doc.source_notes" :key="j" class="tw-mb-2">
                        <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2" v-if="i.aml_types && i.aml_types.includes('fitness-probity')">
                            <a target="_blank" rel="noreferrer" :href="i.url" class="tw-text-blue-600 tw-no-underline tw-font-medium">{{ i.name }}</a>
                            <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-x-2 tw-mt-2">
                                <div v-for="(field, idx) in getFilteredFields(adverseCard.doc.fields, j)" class="tw-break-words" :key="field.value + idx">
                                    <span class="tw-font-medium" :identifier="`['data']['fields'][${idx}]['name']`">{{ field.name }}: </span>
                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :identifier="`['data']['fields'][${idx}]['value']`" :href="field.value">
                                            {{ field.value }}
                                        </a>
                                    </template>
                                    <template v-else>{{ field.value }}</template>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Fitness Probity</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.fitnessComplyExpanded"></div>
            </template>
        </div>

        <div class="tw-mb-2">
            <template v-if="adverseCard.doc.assets">
                <div @click="fetchMoreInfo(adverseCard, 'imagesComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Assets</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.imagesComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-px-2 headingBlock-sibling" v-if="adverseCard.imagesComplyExpanded">
                    <div class="tw-py-4" v-if="getImages(adverseCard.doc.assets).images.length">
                        <h5 class="tw-text-sm tw-text-gray-600">Images</h5>
                        <img referrerpolicy="no-referrer" class="tw-h-60" :identifier="`['data']['assets'][${idx}]['images']['url']`" v-for="(image, idx) in getImages(adverseCard.doc.assets).images" :src="image.url" :key="image.url + idx" />
                    </div>
                    <div class="tw-py-4" v-if="getImages(adverseCard.doc.assets).pdf.length">
                        <h5 class="tw-text-sm tw-text-gray-600">Documents</h5>
                        <a :href="assets.public_url" referrerpolicy="no-referrer" :identifier="`['data']['assets'][${idx}]['pdf']['public_url']`" target="_blank" class="tw-text-brand hover:tw-text-purple-700 tw-block tw-mb-2" :key="assets.public_url + idx" v-for="(assets, idx) in getImages(adverseCard.doc.assets).pdf">
                            {{ assets.public_url }}
                        </a>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Assets</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.imagesComplyExpanded"></div>
            </template>
        </div>

        <div class="tw-mb-2">
            <template v-if="isMedia && getFilteredFields(adverseCard.doc.fields, 'complyadvantage-adverse-media').length > 0">
                <div @click="fetchMoreInfo(adverseCard, 'adverseComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Adverse Media List</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.adverseComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.adverseComplyExpanded">
                    <!-- <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2">
                        <a target="_blank" rel="noreferrer" class="tw-text-blue-600 tw-no-underline tw-font-medium"> ComplyAdvantage Adverse-Media</a> -->
                    <div class="tw-mb-2 tw-flex tw-space-x-2" v-for="(field, idx) in getFilteredFields(adverseCard.doc.fields, 'complyadvantage-adverse-media')" :key="field.name">
                        <div class="tw-w-1/3 lg:tw-w-1/4 tw-font-semibold tw-text-left tw-py-2 tw-pr-3 tw-text-gray-400" :identifier="`['data']['fields'][${idx}]['name']`">
                            {{ field.name }}
                        </div>
                        <div class="tw-w-2/3 lg:tw-h-3/4 tw-pl-3 tw-pr-3 tw-py-2">
                            <div class="tw-flex tw-justify-between tw-items-center">
                                <span class="tw-space-y-2">
                                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :identifier="`['data']['fields'][${idx}]['value']`" :href="field.value">{{ field.value }}</a>
                                    </template>
                                    <template v-else>{{ field.value }}</template>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Adverse Media List</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.adverseComplyExpanded"></div>
            </template>
        </div>

        <div class="tw-mb-2">
            <template v-if="isMedia">
                <div @click="fetchMoreInfo(adverseCard, 'mediaComply')" class="headingBlock print-d-block tw-flex tw-items-center tw-py-1 tw-px-2 tw-bg-blue-50 tw-mt-4 tw-justify-between tw-border tw-border-solid tw-border-blue-200 tw-rounded tw-cursor-pointer hover:tw-shadow-md">
                    <div class="tw-text-lg tw-font-medium">Adverse Media ({{ isMedia ? sorted.length : 0 }})</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-cursor-pointer tw-transition-all tw-transform tw-duration-300 hover:tw-text-brand" :class="{'tw-rotate-180': adverseCard.mediaComplyExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="tw-p-2 headingBlock-sibling" v-if="adverseCard.mediaComplyExpanded">
                    <div v-for="(media, idx) in sorted" :key="media.url + idx" class="tw-border tw-rounded tw-border-solid tw-border-gray-300 tw-p-2 tw-mb-2">
                        <div>
                            <!-- doc.media -->
                            <a target="_blank" rel="noreferrer" :href="media.url" class="tw-no-underline tw-text-blue-600 tw-text-base tw-font-medium" :identifier="`['data']['media'][${idx}]['title'] ['data']['media'][${idx}]['url']`">
                                {{ media.title }}
                            </a>
                        </div>
                        <div class="tw-text-sm tw-text-gray-500 tw-mt-0.5" :identifier="`['data']['media'][${idx}]['date']`">Published: {{ parseDate(media.date) }}</div>
                        <div class="tw-mt-2 tw-text-justify" :identifier="`['data']['media'][${idx}]['snippet']`">
                            {{ media.snippet }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="tw-py-1 tw-px-2 tw-bg-gray-50 tw-mt-4 tw-border tw-border-solid tw-border-gray-200 tw-rounded">
                    <div class="tw-text-lg tw-font-medium">Adverse Media</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.mediaComplyExpanded"></div>
            </template>
        </div>
        <!-- <div class="tw-text-base tw-text-gray-700 tw-mb-2 tw-font-bold tw-mt-4" v-if="isMedia">Adverse Media ({{ adverseCard.doc.media.length }})</div>
        <div class="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-2 tw-mb-2" v-if="isMedia && getFilteredFields(adverseCard.doc.fields, 'complyadvantage-adverse-media').length > 0">
            <div class="print-d-block tw-grid tw-grid-cols-4 tw-gap-y-1 tw-gap-2">
                <div v-for="field in getFilteredFields(adverseCard.doc.fields, 'complyadvantage-adverse-media')" class="tw-break-words" :key="field.name">
                    <span class="tw-font-medium">{{ field.name }}: </span>
                    <template v-if="urlFields.includes(field.name.toLowerCase())">
                        <a class="tw-no-underline tw-text-blue-600" target="_blank" rel="noreferrer" :href="field.value">{{ field.value }}</a>
                    </template>
                    <template v-else>{{ field.value }}</template>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import {get} from "lodash";
import neoAnalyse from "@/components/analyse";
import printDataMixin from "@/mixins/printDataMixin";
import adverseMixin from "@/mixins/adverseMixin";
import highlighterMixin from "@/mixins/highlighterMixin";

export default {
    components: {neoAnalyse},
    data() {
        return {
            urlFields: ["related url", "locationurl", "picture"],
            isPrintLoader: false,
            sorted: [],
            refBtnClick: {
                refNameSection: true,
                refcontryTerritoryDetails: true,
                refDatesSection: true,
                refAddressSection: true,
                refImagesSection: true,
                refRolesSection: true,
                refRelativeCloseDowjonesSection: true,
                refProfileNotesDowjonesSection: true,
                refSourceSection: true,
                refworldcheck: true,
                refAliases: true,
                refCitizenships: true,
                refLocations: true,
                refFurtherInfo: true,
                refInformationSources: true,
                refDetailsComply: true,
                refassociatesComply: true,
                refsanctionsComply: true,
                refwarningComply: true,
                refpep1Comply: true,
                refpep2Comply: true,
                refpep3Comply: true,
                refpep4Comply: true,
                reffitnessComply: true,
                refimagesComply: true,
                refadverseComply: true,
                refmediaComply: true,
            },
        };
    },
    props: {
        expandedCard: {
            type: Object,
        },
        isResultExpanded: {
            type: Boolean,
        },
        isComparisonModeOn: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isMedia() {
            if (this.adverseCard && this.adverseCard.doc.media) {
                let mediaDate = [];
                let noDate = [];
                const date = this.adverseCard.doc.media.map((e) => {
                    if (e.date) {
                        mediaDate.push(e);
                    } else {
                        noDate.push(e);
                    }
                });

                this.sorted = mediaDate.sort((a, b) => {
                    if (a.date && b.date) {
                        const date1 = a.date.split("T");
                        const date2 = b.date.split("T");
                        const aDate = new Date(date1[0]);
                        const bDate = new Date(date2[0]);
                        return bDate.getTime() - aDate.getTime();
                    }
                });
                if (noDate) {
                    noDate.map((e) => {
                        this.sorted.push(e);
                    });
                }
            }
            return this.sorted && this.sorted.length > 0;
        },
        adverseCardKey() {
            return this.expandedCard?.key;
        },
        adverseCard() {
            return this.expandedCard?.api_all_data ?? {};
        },
    },
    watch: {},
    mixins: [adverseMixin, printDataMixin, highlighterMixin],
    mounted() {
        this.highlightChanges();
    },
    methods: {
        get,
        async printPage(value, filename, noPrint) {
            this.isPrintLoader = true;
            await this.handleExpandAll(true);
            const htmlPDF = this.printData(value, filename, noPrint);
            this.$emit("updatePrintStatus", "");
            this.isPrintLoader = false;
            if (noPrint) {
                return htmlPDF;
            }
        },
        getImages(assetsList) {
            let pdf = [];
            let images = [];
            if (assetsList.length) {
                pdf = assetsList.filter((ass) => ass?.type === "pdf");
                images = assetsList.filter((ass) => ass?.type !== "pdf");
                // let others = assetsList
            }
            return {pdf, images};
        },
    },
};
</script>

<style src="./../monitoring-differential-highlighter/monitoring-differential-highlighter.scss" scoped lang="scss"></style>
<style scoped>
@media print {
    svg {
        display: none;
    }
    table {
        page-break-inside: auto !important;
    }
    table td {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table th {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table td div {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    div {
        page-break-inside: auto !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
        box-sizing: content-box !important;
    }
    article {
        margin-bottom: 0.5rem;
    }
    span {
        page-break-inside: auto !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    .tw-break-words {
        display: block;
    }
    .print-d-block {
        display: block !important;
    }
}
</style>
<style scoped>
/* @media print {
        table {
            page-break-inside: auto !important;
        }
        table td {
            page-break-inside: avoid !important;
            page-break-after: auto !important;
            page-break-before: auto !important;
        }
        table th {
            page-break-inside: avoid !important;
            page-break-after: auto !important;
            page-break-before: auto !important;
        }
        table td div{
            page-break-inside: avoid !important;
            page-break-after: auto !important;
            page-break-before: auto !important;
        }
        div {
            page-break-inside: auto !important;
            page-break-after: auto !important;
            page-break-before: auto !important;
            box-sizing: content-box !important;
        }
        span {
            page-break-inside: auto !important;
            page-break-after: auto !important;
            page-break-before: auto !important;
        }
        .searchIcon {
            display: none !important;
        }
        .print-d-block {
            display: block !important;
        }
        .print-d-block article{
            margin-top: 10px !important;
        }
        .print-d-block div{
            margin-top: 10px !important;
        }
        .normal-print-table tr {
            page-break-inside: avoid !important;
        }
    }     */
</style>
